<div
    class="tooltip-container"
    [ngClass]="getClasses()"
    *ngIf="!!text"
    [ngStyle]="getStyles()" [innerHTML]="text"></div>

